export const TABLE_PAGE_SIZE = 10;
export const DEBOUNCE_DELAY = 1_000;
export const SCROLL_HEIGHT = '250px';
export const BREAKPOINTS_SMALLER_LG = ['xs', 'sm', 'md'];
